import { render, staticRenderFns } from "./modalMoveLinkcard.vue?vue&type=template&id=cc15ed08&scoped=true"
import script from "./modalMoveLinkcard.vue?vue&type=script&lang=js"
export * from "./modalMoveLinkcard.vue?vue&type=script&lang=js"
import style0 from "./modalMoveLinkcard.vue?vue&type=style&index=0&id=cc15ed08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc15ed08",
  null
  
)

export default component.exports